import { BFFAgent } from 'BFFAgent';
import {
  UPDATE_VERSION_PRICE_BEGIN,
  UPDATE_VERSION_PRICE_SUCCESS,
  UPDATE_VERSION_PRICE_FAILURE,
  UPDATE_VERSION_PRICE_CLEAR
} from './constants';

export function updateVersionPrice(row, optionSelectedPrice, modelVersionPrice) {
  return async(dispatch) => { 
    dispatch({
      type: UPDATE_VERSION_PRICE_BEGIN,
    });

    try{
      const result = await BFFAgent.Datamasters.updateVersionPrice(row, optionSelectedPrice, modelVersionPrice)
      dispatch({
          type: UPDATE_VERSION_PRICE_SUCCESS,
          data: result,
      });
    }catch(error){
      dispatch({
          type: UPDATE_VERSION_PRICE_FAILURE,
          data: error,
      });
    }
  }
  }

export function clearUpdateVersionPrice(){
  return (dispatch) => {
    dispatch({
      type: UPDATE_VERSION_PRICE_CLEAR
    })
  }
}


export function reducer(state, action) {
  switch (action.type) {
    case UPDATE_VERSION_PRICE_CLEAR:
      return {
        ...state,
        updateVersionPricePending: null,
        updateVersionPriceError: null,
        updateVersionPriceSuccess: null,
      }
    case UPDATE_VERSION_PRICE_BEGIN:
      return {
        ...state,
        updateVersionPricePending: true,
        updateVersionPriceError: null,
        updateVersionPriceSuccess: false,
      };

    case UPDATE_VERSION_PRICE_SUCCESS:
      return {
        ...state,
        updateVersionPricePending: false,
        updateVersionPriceError: null,
        updateVersionPriceSuccess: true,
      };

    case UPDATE_VERSION_PRICE_FAILURE:
      return {
        ...state,
        updateVersionPricePending: false,
        updateVersionPriceError: action.data,
        updateVersionPriceSuccess: false,
      };
    default:
      return state;
  }
}
